import axios from 'axios';

const state = {
    dictMap: {}  // 通用字典池，结构为 { dictType: { dictValue: dictLabel } }
};

const mutations = {
    SET_DICT(state, {dictType, map}) {
        state.dictMap[dictType] = map;
    }
};

const actions = {
    async fetchDict({commit}, dictType) {
        if (state.dictMap[dictType]) {
            // 已有缓存就不用重复请求
            return;
        }
        const res = await axios.get(dynamicConfig.backStageSystem + `/system/dict/data/type/${dictType}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${dynamicConfig.token}`,
                'clientId': `${dynamicConfig.clientId}`
            },
        });
        const dictList = res.data.data;
        // 转换为结构：{ dictValue: { label: ..., class: ... } }
        const map = {};
        dictList.forEach(item => {
            map[item.dictValue] = {
                label: item.dictLabel,
                class: item.listClass || 'default',  // 默认颜色 fallback
                status: item.dictValue
            };
        });
        commit('SET_DICT', {dictType, map});
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
